import React from 'react';

function ModelsSection() {
    return (
        <section className="relative mb-32">
            <div className="md:absolute md:left-[calc(-50vw+22rem)] md:top-0 md:w-[calc(50vw-22rem)] md:text-center mb-6 md:mb-0">
                <h2 className="text-base font-medium text-[#777777] lowercase">models</h2>
            </div>
            <div className="space-y-16">

                <div className="space-y-6">
                    <p className="text-base leading-normal text-[#1C1C1C] font-normal">
                        Last year we released Orpheus TTS. Orpheus TTS has been adopted by the largest leading companies in the world, been downloaded over a million times, and forked and fine-tuned thousands of times.
                    </p>
                    <p className="text-base leading-normal text-[#1C1C1C] font-normal">
                        Since then we've raised $17M, grown the team, and are building the leading speech and avatar models, which are currently — but not for long — private.
                    </p>
                </div>



            </div>
        </section>
    );
}

export default ModelsSection;
